import { Component, h, Prop, Element } from '@stencil/core';

/**
 * COMPNAME is for creating a container for a navigation element that allows the user to click through to the next and previous pages (as well as to a parent page) within a hierarchy
 */
@Component({
  tag: 'aafp-next-and-previous',
  shadow: false,
})
export class AafpNextAndPrevious {
  /**
   * For the previous page's link
   */
  @Prop() previousLink: string;

  /**
   * For The previous page's label on mobile
   */
  @Prop() previousLabelMobile: string = 'Prev';

  /**
   * For the previous page's label on desktop
   */
  @Prop() previousLabelDesktop: string = 'Prev';

  /**
   * For the next page's link
   */
  @Prop() nextLink: string;

  /**
   * For The next page's label on mobile
   */
  @Prop() nextLabelMobile: string = 'Next';

  /**
   * For the next page's label on desktop
   */
  @Prop() nextLabelDesktop: string = 'Next';

  /**
   * For the parent page's title
   */
  @Prop() parentTitle: string;

  /**
   * For the parent page's link
   */
  @Prop() parentLink: string;

  @Element() element: HTMLElement;

  render() {
    return (
      <nav class="adl-next-and-previous" aria-label="Next and Previous Page">
        {this.previousLink && (
          <a href={this.previousLink} class="adl-next-and-previous__prev">
            <i class="material-icons">arrow_back</i>
            <span class="adl-next-and-previous__link-text">
              <span class="adl-next-and-previous__link-text-mobile">{this.previousLabelMobile}</span>
              <span class="adl-next-and-previous__link-text-desktop">{this.previousLabelDesktop}</span>
            </span>
          </a>
        )}
        {this.parentLink && (
          <a href={this.parentLink} class="adl-next-and-previous__parent">
            <span class="adl-next-and-previous__link-text">{this.parentTitle}</span>
          </a>
        )}
        {this.nextLink && (
          <a href={this.nextLink} class="adl-next-and-previous__next">
            <span class="adl-next-and-previous__link-text">
              <span class="adl-next-and-previous__link-text-mobile">{this.nextLabelMobile}</span>
              <span class="adl-next-and-previous__link-text-desktop">{this.nextLabelDesktop}</span>
            </span>
            <i class="material-icons">arrow_forward</i>
          </a>
        )}
      </nav>
    );
  }
}
